import type { ResendVerificationRequest } from './auth.schema';
import { useMutation } from '@tanstack/react-query';
import { authApi } from './auth.api';

export const useResendVerificationMutation = () => {
  return useMutation({
    mutationFn: (data: ResendVerificationRequest) => {
      return authApi.resendVerification(data);
    },
  });
};
